<template>
    <div class="productions-index">
        <header page-transition-group>
            <HeroGraphicText v-if="contentIsLoaded && content.heroGraphicText != null" />
        </header>

        <div class="page-content" page-transition-group>
            <section>
                <div class="container-xxl padding-container">
                    <div
                        class="row default-fliters-wrapper align-items-center justify-content-md-between px-lg-4"
                    >
                        <div
                            class="col-12 col-xxl-auto d-flex align-items-center justify-content-center justify-content-md-start mb-4 mb-xxl-0"
                        >
                            <IconInis name="filter" />
                            <span class="d-inline-block text-uppercase bold ms-3">{{
                                $t('Filtres')
                            }}</span>
                        </div>

                        <div
                            class="col-12 col-lg-auto d-flex flex-column flex-md-row align-items-center mb-5 mb-lg-0"
                        >
                            <div
                                class="d-flex flex-column flex-xl-row align-items-center col-select mb-4 mb-md-0 me-md-2"
                            >
                                <span
                                    class="text-weight-semibold text-small me-md-auto me-xl-2 ms-md-1 mb-2 mb-xl-0"
                                    >{{ $t('Choisir un format') }}</span
                                >
                                <div class="select-wrapper">
                                    <select @change="goToPage(1)" v-model="filters.format">
                                        <option value="">{{ $t('Tout les formats') }}</option>
                                        <option :value="item" v-for="(item, i) in aggregateFormats" :key="i">{{ item }}</option>
                                    </select>
                                </div>
                            </div>

                            <div
                                class="d-flex flex-column flex-xl-row align-items-center col-select ms-md-2"
                            >
                                <span
                                    class="text-weight-semibold text-small me-md-auto me-xl-2 ms-md-1 mb-2 mb-xl-0"
                                    >{{ $t('Sélectionner une année') }}</span
                                >
                                <div class="select-wrapper">
                                    <select v-model="filters.year" @change="setOrder('alphabetique')">
                                        <option value="">{{ $t('Toutes les années') }}</option>
                                        <option :value="item" v-for="(item, i) in aggregateYears" :key="i">{{ item }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-lg-auto">
                            <div
                                class="d-flex flex-column justify-content-center flex-md-row justify-content-md-start align-items-md-center"
                            >
                                <!-- <button class="button">{{ $t('Afficher') }}</button> -->
                                <button class="button-underline-red mt-3 mt-md-0 ms-md-3" @click.prevent="resetFilters">
                                    {{ $t('Réinitialiser') }}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div
                        class="row align-items-center justify-content-center justify-content-md-between padding-container-sm"
                        v-if="productionsListing && productionsListing.items && productionsListing.items.length > 0"
                    >

                        <div class="col-auto">
                            <div class="col-auto">
                                <span>{{ (currentPage * perPage) + 1 + ' ' + $t('à') }}</span>&nbsp;<span v-if="(currentPage + 1) * perPage > productionsListing.pagination.totalResults">{{productionsListing.pagination.totalResults}}</span>
                                <span v-else>{{ (currentPage + 1) * perPage }}</span>&nbsp;<span>{{ $t('de') + ' ' + productionsListing.pagination.totalResults }}</span>
                            </div>
                        </div>



                        <div
                            class="col-12 col-md-auto d-flex align-items-center justify-content-center flex-column flex-md-row mt-3 mt-md-0"
                        >
                            <span class="me-md-4 mb-2 mb-md-0">{{ $t('Trier par') }}</span>
                            <div class="select-wrapper">
                                <select v-model="filters.order">
                                    <option value="recent">{{ $t('Plus récent') }}</option>
                                    <option value="ancien">{{ $t('Plus ancien') }}</option>
                                    <option value="alphabetique">{{ $t('Par ordre alphabétique') }}</option>
                                </select>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="sep-hor-thick-black mt-3"></div>
                        </div>
                    </div>

                    <div class="row results-row">
                        <ProductionCard
                            v-for="(production, index) in productionsListing.items"
                            :key="'production-' + index"
                            :productionData="production"
                            :showColumn="true"
                            :defaultImage="globals.inisGlobalElement.inisDefaultImage.images"
                        />

                        <div class="pagination-loader" :class="{ 'is-loading': isLoading }">
                            <StairInis />
                        </div>
                    </div>

                    <div class="row justify-content-md-end padding-container-bottom" v-if="productionsListing.pagination && productionsListing.pagination.totalPages > 1">


                        <div class="col-12 col-md-6 d-flex align-items-center justify-content-center justify-content-md-start mb-5 mb-md-0">
                            <div class="col-auto">
                                <span>{{ (currentPage * perPage) + 1 + ' ' + $t('à') }}</span>&nbsp;<span v-if="(currentPage + 1) * perPage > productionsListing.pagination.totalResults">{{productionsListing.pagination.totalResults}}</span>
                                <span v-else>{{ (currentPage + 1) * perPage }}</span>&nbsp;<span>{{ $t('de') + ' ' + productionsListing.pagination.totalResults }}</span>
                            </div>
                        </div>

                        <!-- <div class="col-12 col-md-auto">{{ productionsListing.pagination.totalResults }} résultats</div> -->
                        <div class="col-12 col-md-6 pagination-wrap">
                           <a class="pagination-item icon" href="#" v-if="currentPage > 0" @click.prevent="goToPage('prev')"><i class="fa-regular fa-chevron-left fa-2x"></i></a>

                            <a class="pagination-item" :class="{ 'disabled': currentPage === 0 }" :href="'?p=' + 1" @click.prevent="goToPage(1)">1</a>

                            <a class="pagination-item space" href="#" v-if="currentPage >= 5" @click.prevent>...</a>

                            <a class="pagination-item" v-for="i in productionsListing.pagination.previousPages" :key="i" :href="'?p=' + i" :class="{ disabled: i === (currentPage + 1) }" @click.prevent="goToPage(i)">{{ i }}</a>
                            <a class="pagination-item" v-for="i in productionsListing.pagination.nextPages" :key="i" :href="'?p=' + i" :class="{ disabled: i === (currentPage + 1) }" @click.prevent="goToPage(i)">{{ i }}</a>

                            <a class="pagination-item space" href="#" v-if="currentPage <= productionsListing.pagination.totalPages - 5" @click.prevent>...</a>

                            <a class="pagination-item" :class="{ 'disabled': currentPage === (productionsListing.pagination.totalPages - 1) }" :href="'?p=' + productionsListing.pagination.totalPages" @click.prevent="goToPage(productionsListing.pagination.totalPages)">{{productionsListing.pagination.totalPages}}</a>

                            <a class="pagination-item icon" href="#" v-if="(currentPage + 1) < productionsListing.pagination.totalPages" @click.prevent="goToPage('next')"><i class="fa-regular fa-chevron-right fa-2x"></i></a>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { getAllDocs } from '@/firebase/init'

import StairInis from '@/components/svgs/stairInis'
import IconInis from '@/components/svgs/IconInis'
import HeroGraphicText from '@/components/hero/HeroGraphicText.vue'
import ProductionCard from '@/components/loopTemplate/ProductionCard'

export default {
    name: 'Productions',

    components: {
        // AssetLoader,
        HeroGraphicText,
        IconInis,
        ProductionCard,
        StairInis,
    },

    data() {
        return {
            // Firebase Firestore
            firestoreContent: [],
            firestoreErr: null,
            // Productions
            productions: [],
            filters: {
                format: '',
                year: '',
                order: 'recent',
            },
            // Pagination
            perPage: 24,
            currentPage: 0,
            isLoading: false,
        }
    },

    watch: {
        pageIsLoaded: {
            async handler(pageIsLoaded) {
                if (pageIsLoaded) {
                    // Page loaded with Data
                    this.setBgTheme(this.content.heroGraphicText.heroBackgroundColor)
                    if (this.$route.query.p) {
                        this.currentPage = parseInt(this.$route.query.p) - 1
                    }

                    if (this.$route.meta.firebaseCollection) {
                        try {
                            const res = await getAllDocs(
                                this.$route.meta.firebaseCollection,
                                this.$route.meta.firebaseDocument
                            )
                            this.firestoreContent = res
                            this.setFirestoreContentLoaded(true)
                            this.setFirestoreContentData(this.firestoreContent)
                        } catch (e) {
                            this.firestoreErr = e
                        }
                    }
                }
            },
            immediate: true,
        },
    },

    computed: {
        productionsListing() {
            if (!this.contentIsLoaded) {
                return []
            }

            const { format, year, order } = this.filters

            let productions = this.firestoreContent.filter(
                (production) =>
                    (!format || production.format === format) &&
                    (!year || production.year === year)
            )

            if (order === 'recent') {
                productions = productions.sort((a, b) => {
                    return b.year - a.year
                })
            } else if (order === 'ancien') {
                productions = productions.sort((a, b) => {
                    return a.year - b.year
                })
            } else if (order === 'alphabetique') {
                productions = productions.sort((a, b) => {
                    return a.title.localeCompare(b.titleClassement)
                })
            }

            const totalResults = productions.length
            const totalPages = Math.ceil(totalResults / this.perPage)

            const nextPages = []
            let previousPages = []

            for (let i = 1; i <= 3; i++) {
                if (this.currentPage + i < totalPages && this.currentPage + i !== totalPages && this.currentPage + i !== 1 && this.currentPage + i !== 0) {
                    nextPages.push(this.currentPage + i)
                }
                if ((this.currentPage + 1) - i >= 0 && (this.currentPage + 1) - i !== 1 && (this.currentPage + 1) - i !== 0) {
                    previousPages.push((this.currentPage + 1) - i)
                }
            }

            previousPages = previousPages.reverse()

            return {
                items: productions.slice(
                    this.currentPage * this.perPage,
                    (this.currentPage + 1) * this.perPage
                ),
                pagination: {
                    perPage: this.perPage,
                    currentPage: this.currentPage,
                    totalResults,
                    totalPages,
                    nextPages,
                    previousPages,
                },
            }
        },
        aggregateFormats() {
            if (!this.contentIsLoaded) {
                return []
            }
            return this.firestoreContent.map(doc => doc.format).filter(
                (value, index, self) => self.indexOf(value) === index
            )
        },
        aggregateYears() {
            if (!this.contentIsLoaded) {
                return []
            }

            const arrayOfYears = this.firestoreContent.map(doc => doc.year).filter(
                (value, index, self) => self.indexOf(value) === index
            )

            return arrayOfYears.sort((a, b) => {
                return b - a
            })
        },
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals', 'firestoreContentLoaded']),
    },

    methods: {
        ...mapActions(['setErrorsReportMsg', 'setBgTheme', 'setFirestoreContentLoaded', 'setFirestoreContentData']),
        resetFilters() {
            this.goToPage(1)
            this.filters = {
                format: '',
                year: '',
                order: 'recent',
            }
        },
        goToPage(page) {
            this.isLoading = true
            // ScrollTo
            document.querySelector('.page-content').scrollIntoView({
                top: 0,
                behavior: 'smooth',
            })

            if (page === 'prev') {
                this.currentPage--
            } else if (page === 'next') {
                this.currentPage++
            } else {
                this.currentPage = page - 1
            }

            const url = new URL(window.location.href.split('?')[0])
            url.searchParams.set('p', (this.currentPage + 1))
            window.history.pushState({}, '', url);

            // const cardsImg = document.querySelectorAll('.card-header img')
            // cardsImg.forEach(img => {
            //     img.setAttribute('src', '/static-assets/ws.jpg')
            // })

            setTimeout(() => {
                this.isLoading = false
            }, 3295)
        },
        setOrder(order) {
            this.currentPage = 0
            this.filters.order = order
            this.goToPage(1)
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
